// =========================================================
// FACTQRY - MODAL GUIDE DES TAILLES
// Version avec ajout automatique des pictogrammes
// =========================================================

(function() {
  'use strict';
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeGuideModal);
  } else {
    initSizeGuideModal();
  }
  
  function initSizeGuideModal() {
    const modal = document.getElementById('FQSizeGuideModal');
    if (!modal) {
      return;
    }
    
    const closeBtn = modal.querySelector('[data-modal-close]');
    const overlay = modal.querySelector('[data-modal-overlay]');
    const contentDiv = document.getElementById('fq-modal-content');
    
    if (!contentDiv) {
      return;
    }
    
    let contentLoaded = false;

    // FACTQRY-HOOK (2026-10-05) : textes et URL fournis par la modale (Liquid, langue du visiteur)
    const DATA = modal.dataset;
    const GUIDE_URL = DATA.guideUrl || '/pages/guide-des-tailles';
    const TEXT_LOADING = DATA.textLoading || 'Chargement du guide des tailles...';
    const TEXT_ERROR = DATA.textError || 'Impossible de charger le guide des tailles.';
    const TEXT_OPEN = DATA.textOpen || 'Ouvrir dans une nouvelle fenêtre';
    const ALT_TSHIRT = DATA.altTshirt || 'Mesures T-shirt';
    const ALT_SWEATSHIRT = DATA.altSweatshirt || 'Mesures Sweatshirt';
    
    // FACTQRY (7 oct. 2026) : pictogrammes dessinés dans la page (SVG intégré) au lieu d'images chargées depuis
    // le CDN, qui restaient cassées dans certains navigateurs d'ordinateur. Tracés identiques aux fichiers
    // PICTOGRAMME_T-SHIRT / PICTOGRAMME_PULL_GUIDE_DES_TAILLES.svg.
    const PICTO_SVG = {
      tshirt: { viewBox: '0 0 808.3 733.2', ratio: '808.3 / 733.2', paths: '<path fill="#2a3d2d" d="M296,0c13.1,7.4,25.4,14.1,40,18.5,45.6,13.7,102.7,10.9,147.3-5.5,10.1-3.7,19.5-9.6,29.8-12,58.5,26.4,130.8,41.6,175.9,89.8,32.4,34.7,60.4,78.1,90.4,115.3,9.7,12.1,21.6,22.6,28.9,36.5v3l-2.9,4.6-139.2,107.6c-9.8,4.2-27-21.2-29.7-18.2-.9,6.2.9,12.5,1,18.4,3.2,114.8-3.4,230-2.1,344.6.1,9.7,5,24-6.7,29.1-107.2,3-215,.4-322.4,1.3-40.2-4.7-85,2.7-124.8-1-2.9-.3-10.4-4.2-10.4-6.5v-385c-11.9,2.8-18.3,22.9-32.7,15.2s-24.7-19.4-34.4-26.6c-30.7-22.7-68.6-47-96.2-72.5s-9.7-7.7-7.1-16L130.2,78.4c12.4-13.3,29.5-20.6,45.6-28.3C213.7,31.8,253,16,292,0h4ZM301,36c11,98.8,165.5,111.8,199.5,21.2,1.3-3.5,7.1-19.7,4.3-21.8s-13.4,4.5-16.5,5.6c-45.1,15.5-99,18.2-145.5,7.7s-27.6-9.2-41.8-12.7ZM612.6,706V242.2c0-.3,3.8-3.8,4.6-4.3,7.4-4.4,16.7-2.2,19.1,6.6,3.2,12-.6,25.6-.8,37.7s.7,11.8,1.2,17.8l26.4,26.6,110.8-86.9-124-152.7-116.9-50.9-2.2,1.7c-7.3,77.2-86,119.6-158,104.7-49.8-10.3-94-52.2-97.9-104.4-2.2-2.4-54.4,19.7-60.9,22.5-16.1,6.9-35.3,14.5-49.9,24-12.1,7.9-21.6,20.8-31,31.9-34.9,40.8-67.7,83.6-100.9,125.8l111.2,85.3,27.4-28.6c2.8-14.4-6.4-47,2.3-58.6s12.5-5.5,17.8-2.1,5,5,5,6v462.9l416.5-1Z"/><path fill="#2a3d2d" d="M537.7,76.9l-7.7,5.8c-9.4,2.6,5-16.9,7.1-18.9s4.1-3.1,6.3-1.7,11.8,15.5,12,16.5c.8,3.7-.7,4.5-4.1,4.1s-3.5-5.2-6.7-6.8v198.7h40.9c-1.4-2.9-6.5-4.1-6.8-7.7s2.9-3.7,5.1-3.1,17.1,12.2,16.8,15.3-15.6,13.4-17.6,13.6-2.1-.2-3-.9l-1.5-2.6,6-7.5h-40v392.5c2.6-.5,3.7-5.2,5.7-5.8,12.5-4.3-2.6,15.2-5.1,17.8s-4.1,4.6-7.5,1.5-10.9-15.1-11-16.1c-.4-4.2,4.2-4.3,6.7-2.1s1.3,5.4,4.3,4.7v-392.5H223c-.3,3.3,10.1,7,5,10.5s-21.1-10.9-21.1-14,15.3-13.8,17.7-14.3,5.1.8,4.1,4.1-5.5,4.2-6.8,6.7h315.6V76.9Z"/><path fill="#2a3d2d" d="M454.8,671.1v-60.9h27.5c.6,0,9.4,3,10.4,3.6,9.3,5.5,7.7,20.4-1.9,24.9,9.3,5.4,13.1,15.1,6.5,24.5-2,2.8-9.9,7.9-13,7.9h-29.5ZM467.7,635.1c6,0,18.1.9,18.1-7.5s-11.8-7.5-18.1-7.5v15ZM467.7,661.1c7.1.4,20.7,1.2,19.9-9.4s-13.8-7.8-19.9-7.5v17Z"/><path fill="#2a3d2d" d="M305.9,251.7l-12-.5-4.8-12.9-22.9-.5-5.1,13.4-12,.5,22-60.4c3.6-.4,12.8-1.8,14.9,1.1l20.1,59.3ZM270,226.7h16l-7.5-26c-2-.4-1.4.8-1.9,2-3.2,7.2-4.3,16.4-6.5,24Z"/>' },
      sweatshirt: { viewBox: '0 0 741.6 788.1', ratio: '741.6 / 788.1', paths: '<path fill="#2a3d2d" d="M335.8,788c-47.7-.5-98.6-2-146.3-7-7.7-.8-27.4-1.5-30-9.9s-1.3-9.6-1.3-11.6c-.3-15.8,6.6-47.6,1.1-61s-4.9-7.3-5.7-7.3c-2.8,2.6-4.5,6.2-7,9s-13.6,11.8-14.7,14.2c-4.1,9.1-3.6,31.3-6.2,42.7-2.5,10.7-3.5,13.5-15,12.9-13.6-.7-31-3.3-44.8-5.1-12.2-1.5-36.8-3.5-47.3-7.7s-6.3-6.4-6.4-11.7c-.2-14.9,5.9-31.7,6-46.9-26.4-43.2-17.6-99.5-12.9-147.9,4.2-43,10.5-86,17.1-128.7,12.2-78.4,25.1-162.1,41.1-239.5,5.2-25.2,12.9-57.3,26.9-79,26.2-40.7,90.9-57,133-76.7C236,21,269.9,0,281.4,0c11.1,0,31.8,7.5,44.3,9.8,31.3,5.6,64.7,6.7,95.9-.4,10.4-2.4,22.6-7.7,32.9-9.1,14-1.8,38.7,14.6,52.5,20.9,46.7,21.3,124.5,43.4,149.7,91,8.7,16.5,14.4,38.1,18.5,56.4,15.5,69.6,26.7,146.7,38.1,217.6,7.4,46.1,14.6,92.4,20,138.8,5.3,45,15.1,107,1.6,150.2s-11.4,19.3-10.5,34.4,7.1,30.7,4.3,41.3c-1.9,7.1-7.8,7-13.9,8-24.3,4.2-56.5,9.5-80.8,11.1-12.9.8-14.8,0-17.8-12.1-2.5-10-2.4-20.1-3.8-30.2-2.8-19.2-4.3-13.1-15.3-24.6-1.5-1.6-8.8-13.2-10.5-12-.2,3.5-3.5,6.1-4.5,9-2.2,6-1.7,17-1.5,23.5.4,12.2,4.5,31.6,2.9,42.8-.2,1.8-1.9,6.5-2.9,7.8-3.2,4.3-25.2,6-31.5,6.7-55.4,5.9-117.6,6.6-173.3,7-13.3,0-26.7.1-39.9,0ZM456.6,14.1c-47.7,14.9-96.1,16.9-145,6.7-8.3-1.7-16.6-4.8-24.5-6.4-.9-.2-3.3-.8-3.3.3,2.7,6.5,7.9,20.8,14,24,16.4,8.4,61.6,13,80.4,12.5s51.7-5.1,64.1-11.8,12.1-17.6,14.3-25.2ZM269.6,17.2l-26.6,14.5c30,67.3,115.4,92.4,181.9,67.1,31.3-12,59.3-35.1,72.5-66.3.3-1.3-.7-1.6-1.5-2.2-2.3-1.6-24.4-13.4-25.8-13.1-2.7,5.6-4.1,11.6-6.8,17.2-33,66.7-158.1,65.2-187.7-3.5s-2.8-13.9-6.1-13.5ZM506.6,36c-22.5,58.9-92.3,88.3-152.3,82.9-42-3.8-86.7-27.2-110.2-62.6-2.2-3.3-10.1-19.8-12.7-20-41.2,22.5-92.5,30.4-124.3,67.3,26.9,32.7,38.2,73,45.6,114,21.2,118,6.2,245.9,2.3,365.2-1,30.4-5.9,77.8,10.6,104.3,2.8,4.5,5.4,9.2,11,10,13.7,1.9,29.1.7,42.9,1,37.6,1,75.2.9,112.8,1,72.5.2,146.3,2.2,218.7-1.9s19.5,2.1,28.3-15.6c13.8-27.6,7.3-93.6,6.1-125.6-4.1-113.9-17-230.3,4.4-343.3,7.4-39.4,18.7-77.7,44.6-109-14.4-19.1-36.9-29.1-58.2-38.8-19.9-9-43.4-19.6-63.6-27.3-1.9-.7-3.8-1.7-6-1.5ZM427.7,53c-37.6,9.5-76.2,9.1-113.8,0,31.7,23.3,82,23,113.8,0ZM101.8,115.2c-.5-.5-2.1-1.5-2.7-.9-7.5,13-12.1,27.6-15.9,42.1-19.5,74.3-31.1,158.5-42.8,234.8-11.4,73.8-31,170.4-27.1,243.5,1,19.6,2.2,37.7,13.7,54.5l98.7,12.9c5-.3,18.4-17,20-21.9,3.3-9.9-1.8-23.2-2.6-33.4-3.1-43.7,3.1-99.1,5-143.9,4.5-105.4,17.6-258.3-26.7-355.6-3.6-7.9-13.3-26.4-19.4-32ZM643.4,113.9c-1.8-1.4-9.6,9.9-10.8,11.7-21.2,30.7-30.4,74.3-36,110.8-17.4,115.2-2.2,232.6.8,348.4.5,20.9,2.7,43,1.1,63.9s-5.2,18.4-4.1,28,14.7,25,21.5,25.4l98.6-12.9c7.8-11.3,11.9-25,13.5-38.6,5.9-48.9-6.7-122.6-14-172.5-11.9-81.4-24.8-164.7-40.1-245.5-7.5-39.8-14.2-81.6-30.7-118.6ZM119.1,713.1l-87.9-10c-2.6,14.1-4.1,28.5-4,42.9l84.9,11,7-43.9ZM715.3,746c-1.3-12-1.4-24.4-3.1-36.3-.3-1.8-.8-5.9-2.5-6.5l-86.3,9.9,6,43.9,85.8-11ZM569.4,765l-2.1-57.2-1.3-1.4c-3.8.5-8.3,1.6-12,1.8-89.8,4.2-182.8,3.6-272.6,1.9-13-.2-26,.2-39,0l-69.4-4-1.1,58.3c12.6,2.6,25.7,4.4,38.5,5.6,93.7,8.7,197.8,8.2,291.6,2,22.5-1.5,45.1-3.7,67.4-7Z"/><path fill="#2a3d2d" d="M507.6,94l-11-.5c3.3-6.3,6.4-12.9,10.2-18.8s4.4-7.7,6.3-7.7l15.5,25.5c.3,2,0,1.3-1.5,1.5-2.9.4-6.5-.3-9.5,0v209.7h26c.3-3.3-.4-7.3,0-10.5s-.6-1.7,1.5-1.5l24.5,16.5c.3,1.4-.9,1.7-1.7,2.3-2.1,1.8-21.5,14.9-22.8,15.2-2,.4-1.3-.3-1.5-1.5-.5-3.5.4-7.9,0-11.5h-26v352.5c3.3.3,7.3-.4,10.5,0s1.7-.5,1.5,1.5l-15.5,26.5c-4.2,0-14.7-23.8-18.5-27.5l12-.5v-351l-1.5-1.5H198c-.4,3.6.5,8,0,11.5s.5,1.9-1.5,1.5-25.4-15-25.4-16.5l24.5-17.5c2.2-.3,1.2.3,1.5,1.5.8,3.3,1.1,7,1,10.5h309.6V94Z"/><path fill="#2a3d2d" d="M461.1,453.5c23.6,3.2,29.4,30.2,9.5,42.9,18.1,3.9,19.8,28.5,5.9,38.4-1.2.8-8.6,4.6-9.4,4.6h-44.4v-85.9c12,1.2,26.8-1.6,38.4,0ZM439.6,488.4c10.9,2.9,30.8.9,25.5-15s-6.6-5.9-7-5.9h-18.5v21ZM439.6,502.4v23h21.5c.4,0,5.9-3.9,6.2-4.3,3-3.8,1.1-11.4-2.1-14.7-6.7-7-17.4-2.4-25.5-3.9Z"/><path fill="#2a3d2d" d="M215,283.7l31.4-86.9,19.4.2,31.1,86.8h-18l-6.9-19.5h-32s-8,19.5-8,19.5h-17ZM247.4,249.7c5.9.8,13.3-.6,19.5,0l-10.5-35-12.3,31.7-.2,2.2c1.3-.3,2.7.9,3.5,1.1Z"/>' },
    };

    /**
     * Construit le pictogramme SVG (type : 'tshirt' ou 'sweatshirt'), avec son texte alternatif.
     */
    function buildPictoSvg(type, label) {
      const data = PICTO_SVG[type];
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', data.viewBox);
      svg.setAttribute('class', 'fq-picto-svg');
      svg.setAttribute('role', 'img');
      svg.setAttribute('aria-label', label || '');
      svg.style.aspectRatio = data.ratio;
      svg.innerHTML = data.paths;
      return svg;
    }

    /**
     * Remplace les images de pictogrammes de la page « Guide des tailles » (img PICTOGRAMME_…) par le SVG intégré.
     */
    function inlinePictograms() {
      contentDiv.querySelectorAll('img[src*="PICTOGRAMME_"]').forEach(img => {
        const src = img.getAttribute('src') || '';
        const type = src.indexOf('PICTOGRAMME_PULL') !== -1 ? 'sweatshirt'
          : (src.indexOf('PICTOGRAMME_T-SHIRT') !== -1 ? 'tshirt' : null);
        if (!type) return;
        const label = img.getAttribute('alt') || (type === 'tshirt' ? ALT_TSHIRT : ALT_SWEATSHIRT);
        img.replaceWith(buildPictoSvg(type, label));
      });
    }
    
    /**
     * Détecte le type de vêtement basé sur le titre du h2/h3
     */
    function detectGarmentType(heading) {
      const text = heading.textContent.toLowerCase();
      
      if (text.includes('sweatshirt') || text.includes('pull') || text.includes('hoodie') ||
          text.includes('sweater') || text.includes('sudadera') || text.includes('jersey') || text.includes('suéter')) {
        return 'sweatshirt';
      }
      
      if (text.includes('t-shirt') || text.includes('tshirt') || text.includes('tee') || text.includes('camiseta')) {
        return 'tshirt';
      }
      
      return null;
    }
    
    /**
     * Convertit tous les h1-h6 du contenu chargé en <div> stylés équivalents pour
     * éviter de polluer la hiérarchie SEO de la page produit. À appeler APRÈS
     * wrapTablesWithPictograms (qui s'appuie sur les h2/h3 pour identifier le
     * type de vêtement).
     */
    function demoteHeadings() {
      const headings = contentDiv.querySelectorAll('h1, h2, h3, h4, h5, h6');
      headings.forEach(heading => {
        const level = heading.tagName.charAt(1);
        const replacement = document.createElement('div');
        replacement.className = ('fq-modal-heading fq-modal-heading--' + level + ' ' + (heading.className || '')).trim();
        replacement.innerHTML = heading.innerHTML;
        if (heading.id) replacement.id = heading.id;
        heading.parentNode.replaceChild(replacement, heading);
      });
    }

    /**
     * Wrappe les tableaux avec leurs pictogrammes
     */
    function wrapTablesWithPictograms() {
      const tables = contentDiv.querySelectorAll('table');
      
      tables.forEach(table => {
        // Éviter de wrapper plusieurs fois
        if (table.closest('.fq-table-wrapper')) return;
        
        // Chercher le h2/h3 précédent pour déterminer le type
        let heading = table.previousElementSibling;
        while (heading && !['H2', 'H3'].includes(heading.tagName)) {
          heading = heading.previousElementSibling;
        }
        
        if (!heading) return;
        
        const garmentType = detectGarmentType(heading);
        if (!garmentType) return;
        
        // Créer le wrapper
        const wrapper = document.createElement('div');
        wrapper.className = 'fq-table-wrapper';
        
        // Créer le pictogramme
        const pictogram = document.createElement('div');
        pictogram.className = 'fq-table-pictogram';
        pictogram.appendChild(buildPictoSvg(garmentType, garmentType === 'tshirt' ? ALT_TSHIRT : ALT_SWEATSHIRT));
        
        // Insérer le wrapper avant le tableau
        table.parentNode.insertBefore(wrapper, table);
        
        // Déplacer le tableau dans le wrapper
        wrapper.appendChild(table);
        
        // Ajouter le pictogramme
        wrapper.appendChild(pictogram);
        
      });
    }
    
    function loadContent() {
      if (contentLoaded) return;
      
      contentDiv.innerHTML = '<div class="fq-loading"></div>';
      contentDiv.firstChild.textContent = TEXT_LOADING;
      
      fetch(GUIDE_URL)
        .then(response => {
          if (!response.ok) throw new Error('Erreur réseau: ' + response.status);
          return response.text();
        })
        .then(html => {
          // Extraire le contenu principal
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          
          // Essayer plusieurs sélecteurs pour trouver le contenu
          let mainContent = 
            doc.querySelector('.page-width .rte') || 
            doc.querySelector('.main-page-content') ||
            doc.querySelector('main .rte') ||
            doc.querySelector('.shopify-section') ||
            doc.querySelector('main');
          
          if (mainContent) {
            // Nettoyer le contenu
            const unwantedSelectors = [
              '.breadcrumb', 
              '.page-header', 
              'header', 
              'footer',
              '.shopify-section-header',
              '.announcement-bar'
            ];
            
            unwantedSelectors.forEach(selector => {
              const elements = mainContent.querySelectorAll(selector);
              elements.forEach(el => el.remove());
            });
            
            contentDiv.innerHTML = mainContent.innerHTML;
            contentLoaded = true;
            
            // Ajouter les pictogrammes puis retirer les titres SEO (ordre important :
            // wrapTablesWithPictograms s'appuie sur les h2/h3 originaux).
            setTimeout(() => {
              wrapTablesWithPictograms();
              inlinePictograms();
              demoteHeadings();
            }, 100);
            
          } else {
            throw new Error('Contenu principal non trouvé dans la page');
          }
        })
        .catch(error => {
          contentDiv.innerHTML = `
            <div style="padding: 40px 20px; text-align: center;">
              <p style="color: var(--fq-dark, #2A3D2D); margin-bottom: 20px;"></p>
              <a 
                target="_blank"
                style="display: inline-block; padding: 12px 24px; background: var(--fq-selected, #B4B4A4); color: white; text-decoration: none; border-radius: 8px; font-weight: 600;"
              ></a>
            </div>
          `;
          contentDiv.querySelector('p').textContent = TEXT_ERROR;
          const openLink = contentDiv.querySelector('a');
          openLink.href = GUIDE_URL;
          openLink.textContent = TEXT_OPEN;
        });
    }
    
    function openModal() {
      modal.showModal();
      document.body.classList.add('fq-modal-open');
      loadContent();
      if (closeBtn) setTimeout(() => closeBtn.focus(), 100);
    }
    
    function closeModal() {
      modal.close();
      document.body.classList.remove('fq-modal-open');
    }
    
    // Délégation au niveau document : robuste aux re-renders Shopify (changement de variante,
    // mise à jour DOM par apps tierces, etc.). Un seul listener pour tous les triggers présents
    // ou futurs.
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-size-guide-trigger]');
      if (!trigger) return;
      e.preventDefault();
      openModal();
    });
    
    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        closeModal();
      });
    }
    
    if (overlay) {
      overlay.addEventListener('click', () => {
        closeModal();
      });
    }
    
    modal.addEventListener('cancel', (e) => {
      e.preventDefault();
      closeModal();
    });
    
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.open) {
        e.preventDefault();
        closeModal();
      }
    });
    
  }
})();
